import { render } from "./ForgetPasswordReset.vue?vue&type=template&id=7a89b389&scoped=true&ts=true"
import script from "./ForgetPasswordReset.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordReset.vue?vue&type=script&lang=ts"

import "./ForgetPasswordReset.vue?vue&type=style&index=0&id=7a89b389&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a89b389"]])

export default __exports__